import Resource from '@/api/resources/Resource'

class MunicipalityConfigurationServices extends Resource {
    async paginator(filterModel, params) {
        const response = await this.axios.put(`/configuration/municipalities`, filterModel, { params })
        return response.data
    }
    async patchMunicipalitiesBatch(municipalities) {
        const response = await this.axios.patch(`/configuration/municipalities/batch`, municipalities)
        return response.data
    }
    async createMunicipality(municipality) {
        const response = await this.axios.post(`/configuration/municipalities`, municipality)
        return response.data
    }
    async deleteMunicipalitiesBatch(municipalities) {
        const data = {
            entityIdentifiers: municipalities
        }
        const response = await this.axios.delete(`/configuration/municipalities/batch`, { data: data })
        return response.data
    }
}

export default new MunicipalityConfigurationServices()
